export class CountryRequest{
    countryId : number;
    
    constructor(countryId : number)
    {
        this.countryId = countryId;
        
    }
}
